<template>
  <b-row
    :id="article.linkId"
  >
    <b-col
      lg="4"
      md="12"
    >
      <h3 class="f-s-24 l-h-153-p l-s-175 font-weight-bolder black-1 b-text">
        {{ article.header }}
      </h3>
    </b-col>
    <b-col
      lg="8"
      md="12"
    >
      <ParagraphGroup
        :context="article.context"
        p-distance
      />
    </b-col>
  </b-row>
</template>

<script>
import ParagraphGroup from '@/components/Article/ParagraphGroup';

export default {
  name: 'Article',
  components: {
    ParagraphGroup,
  },
  props: {
    linkId: {
      type: String,
      default: '',
    },
    article: {
      type: Object,
      default: null,
    },
  },
};
</script>
